import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as AirRoadJobsProductsCustomTableDataItem } from '@/components/customTables/AirRoadJobsProductsCustomTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import _upperFirst from 'lodash/upperFirst';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  arJobItem: ReadonlyDeep<openapi.AirroadItemOpenapi>,
): AirRoadJobsProductsCustomTableDataItem {
  return {
    type: _upperFirst(getStrCell(arJobItem.item_type)),
    volume: getStrCell(
      arJobItem.volume != null
        ? arJobItem.volume.toString() + ' m³'
        : arJobItem.volume,
    ),
    weight: getStrCell(
      arJobItem.weight != null
        ? arJobItem.weight.toString() + ' kg'
        : arJobItem.weight,
    ),
  };
}
